export default __webpack_public_path__ + "static/media/Sample_Thermocycler.c428fb5d.svg";